<template>
    <f7-page name="textova-predpoved-pocasia" @page:init="onPageInit">
        <f7-navbar>
            <f7-nav-left>
                <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
            </f7-nav-left>
            <f7-nav-title sliding>Textová predpoveď</f7-nav-title>
            <f7-nav-right>
                <f7-link icon-ios="f7:arrow_2_circlepath" icon-aurora="f7:arrow_2_circlepath" icon-md="material:autorenew" @click="pageReload($event,false) " href="#" ></f7-link>
                <f7-link icon-ios="f7:arrow_left" icon-aurora="f7:arrow_left" icon-md="material:arrow_back" @click="$f7router.back()" href="#" ></f7-link>
            </f7-nav-right>
        </f7-navbar>
        <template v-if="isForecastLoaded">
            <f7-list class="ss-list">
                <f7-list-item title="Oblasť:"
                              class="textova-predpoved-ss-list"
                              smart-select
                              :smart-select-params="{openIn: 'popup', scrollToSelectedItem:true, closeOnSelect: true, pageTitle:'Vyberte oblasť', popupCloseLinkText:'Návrat', searchbar: true, searchbarPlaceholder: 'Hľadať...'}">
                    <select name="station" v-model="selectedForecastKey" @change="onSelectForecast($event)">
                        <option v-for="(value, key) in forecastData" :key="key" :value="value.section_key">{{ value.section_name }}</option>
                    </select>
                </f7-list-item>
            </f7-list>
            <f7-block v-if="selectedForecastKey !== null" class="no-margin no-padding">

                <f7-list accordion-list class="no-margin text-forecast">
                    <f7-list-item accordion-item v-for="(value, key) in selectedForecastData.section_forecasts"
                                  :key="key"
                                  :title="value.dt_ts | moment('dddd - DD.MM.YYYY') | capitalize"
                                  :class="selectedForecastKey + '-' + value.dt_ts">

                        <f7-accordion-content>
                            <f7-block>
                                <div class="margin-bottom-half"><strong class="text-uppercase">Situácia: </strong>
                                    <div class="margin-top-half" v-html="value.situacia"></div>
                                </div>
                                <template v-if="value.type === 'preformat'">
                                    <pre>{{ value.predpoved }}</pre>
                                </template>
                                <template v-else>
                                    <div class="margin-bottom-half"><strong class="text-uppercase">Predpoveď: </strong>
                                        <div class="margin-top-half" v-html="value.predpoved"></div>
                                    </div>
                                </template>
                                <div><small class="text-color-gray text-uppercase"> {{ value.vydal }}</small></div>

                            </f7-block>
                        </f7-accordion-content>
                    </f7-list-item>
                </f7-list>


            </f7-block>

        </template>
    </f7-page>
</template>
<script>
    import Axios from "axios";
    import SHMUconf from "../js/SHMUconf";


    export default {
        data: function () {
            return {
                stations: [],
                forecastData: {},
                selectedForecastData: {},
                selectedForecastKey: null,
                isForecastLoaded: false,
                isDataLoaded: false,
                lastUpdated: 0,
                tCheckInterval: null,
            };
        },
        filters: {
            capitalize: function(s) {
                return s.charAt(0).toUpperCase() + s.slice(1)
            }
        },
        mounted() {
            const self = this;
            // otvorime hlavne menu
            this.$f7.accordion.close('.shmu-i-pocasie');
            this.$f7.accordion.open('.shmu-i-pocasie');

        },
        updated() {
            if (this.selectedForecastKey === null && this.forecastData.length > 0) {
                this.$f7.smartSelect.get('.textova-predpoved-ss-list .smart-select').open();
            } else {
                this.$f7.accordion.open('.' + this.selectedForecastKey + '-' + this.selectedForecastData.section_forecasts[0].dt_ts);
            }

        },
        destroy() {
            clearInterval(this.tCheckInterval);
        },
        methods: {
            onPageInit() {
                this.pageReload(null, true);
            },
            pageReload(event, isInit) {
                const self = this;

                if (isInit || (this.$moment().unix() - this.lastUpdated) > 60) { // ak posledne stiahnutie bolo menej ako 1 min, tak nedovolime refresh

                    self.$f7.dialog.preloader('Načítavam...');

                    Axios.get(SHMUconf.API_BASE_URL + 'meteo/gettextforecast', {
                        crossDomain: true,
                        cache: false,
                    })
                        .then((response) => {
                            if (!response.data.error) {
                                self.forecastData = response.data;
                                self.selectedForecastKey = this.$ls.get('text_forecast_key');
                                self.isForecastLoaded = true;

                                self.lastUpdated = self.$moment().unix();
                                // clearInterval(this.tCheckInterval);
                                // this.tCheckInterval = setInterval(this.checkLastUpdated, 60*1000); // overujem kazdu minutu

                                self.loadForecastData();
                            } else {
                                self.$f7.dialog.alert('Nepodarilo sa načítať aktuálne textové predpovede', 'Nastala chyba');
                            }

                            self.$f7.dialog.close();
                        }).catch((error) => {
                        self.$f7.dialog.close();
                        self.$f7.dialog.alert('Nepodarilo sa nadviazať spojenie so serverom SHMÚ', 'Nastala chyba spojenia');
                    });
                }


            },
            onSelectForecast(event) {
                this.selectedForecastKey = event.target.value;
                this.loadForecastData();
                this.$ls.set('text_forecast_key', this.selectedForecastKey);
            },
            loadForecastData() {
                const self = this;

                if (self.selectedForecastKey === null) {
                    // ak nie je vybrany kluc, nic nerobime, v updated funkcii sa otvori vyber sekcii
                } else {

                    let obj = self.forecastData.find(item => (item.section_key) === self.selectedForecastKey);
                    self.selectedForecastData = obj;
                }

            },
            checkLastUpdated() {
                if ((this.$moment().unix() - this.lastUpdated) > 5*60) { // ak posledne stiahnutie bolo pred vic ako 5 min, tak refresh
                    this.pageReload(null, false);
                }
            }

        }

    };
</script>

<style lang="scss">

    .text-forecast {
        ul {
            &:before {
                display: none;
            }
            .item-content {
                padding-left:0;
                .item-title {
                    padding-left: calc(var(--f7-list-item-padding-horizontal) + var(--f7-safe-area-left));
                }
            }
            li.accordion-item-opened {
                .item-title {
                    font-weight: bold;
                }
            }

        }
        pre {
            overflow: auto;
            font-size: 10px;
        }
    }

</style>
